var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.212 10.54c-.326-.302-.602-.57-.824-.79.222-.22.498-.488.824-.79A37.01 37.01 0 0 1 6.28 5.698C9.733 3.313 14.406 1 19.5 1c5.094 0 9.767 2.313 13.22 4.698a37.01 37.01 0 0 1 4.068 3.262c.326.302.602.57.824.79-.222.22-.498.488-.824.79-.96.89-2.35 2.076-4.068 3.262-3.453 2.385-8.126 4.698-13.22 4.698-5.094 0-9.767-2.313-13.22-4.698a37.002 37.002 0 0 1-4.068-3.262Z",
    stroke: "#1E1F23",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 9.5,
    r: 4.5,
    stroke: "#1E1F23",
    strokeWidth: 2
  })));
};

export default SvgEyeOpen;